import { z } from 'zod'
import { enumerated } from '../enumerated'
import { feature, multiPolygon, polygon } from './geo'

export const delimitationType = enumerated({
  community: 'Comunidade',
  neighborhood: 'Bairro',
  district: 'Distrito',
  street: 'Rua',
  municipality: 'Município',
  microRegion: 'Microrregião',
  mesoRegion: 'Mesorregião',
  state: 'Estado',
  macroRegion: 'Macrorregião',
  country: 'País',
  custom: 'Personalizado',
})

export const childrenType = enumerated({
  community: 'Comunidade',
  neighborhood: 'Bairro',
  street: 'Rua',
  municipality: 'Município',
  district: 'Distrito',
  microRegion: 'Microrregião',
  mesoRegion: 'Mesorregião',
  state: 'Estado',
  macroRegion: 'Macrorregião',
  country: 'País',
  custom: 'Personalizado',
  item: 'Item',
})

export const childrenItemView = enumerated({
  heatmap: 'Mapa de calor',
  cluster: 'Agrupamento',
  marker: 'Marcador',
  item: 'Item para listagem',
})

export function spaceForPoint() {
  return z.object({
    delimitationType: delimitationType.nullish().describe('Tipo de delimitação'),
    delimitationId: z.union([z.number(), z.string().min(1)]).nullish().describe('ID da delimitação'),
    delimitationCustom: z
      .union([feature(multiPolygon()), feature(polygon())])
      .nullish()
      .describe('Delimitação personalizada'),
    delimitationTitle: z.string().nullish().describe('Título da delimitação'),
    childrenType: childrenType.nullish().describe('Tipo dos filhos'),
    childrenKey: z.string().nullish().describe('Chave dos filhos'),
    childrenTitle: z.string().nullish().describe('Título dos filhos'),
    childrenItemView: childrenItemView.nullish().describe('Visualização dos itens filhos'),
    childrenH3Resolution: z
      .number()
      .positive()
      .nullish()
      .describe('Resolução H3 dos filhos, quando agrupamento ou mapa de calor, sempre opcional'),
  })
}

export type SpaceForPoint = z.infer<ReturnType<typeof spaceForPoint>>
